import { prefetchOrganisationHierarchy } from "../../../api/organisations";
import type { NavigationItemType } from "../../../root/layout/SidebarMenuItem";
import type { Paths } from "../../../shared/usePrivacyNavigate";
import { OrganisationStructurePage } from "./OrganisationStructurePage";

export const route: NavigationItemType["route"] = {
  path: "settings/organisation",
  element: <OrganisationStructurePage />,
};
export const to = (paths: Paths) => paths.organisationStructure();
export const prefetch = prefetchOrganisationHierarchy;
